export const H1_BASE_CSS_VARS = {
  "theme-website-h1-color-text": "var(--theme-website-color-text-primary)",
  "theme-website-h1-font-family": "InterVariable",
  "theme-website-h1-font-size": "3.875rem",
  "theme-website-h1-font-weight": "700",
  "theme-website-h1-line-height": "1.1",
  "theme-website-h1-letter-spacing": "-0.0775rem",
};
